module.exports = __webpack_public_path__ + "img/aayush.b6db0bbf.jpg";